// utils/avatars.js
//
// Simple initials avatar. Every user gets a circle with their initial on a
// colored background. The background is auto-assigned (deterministic per user,
// so it looks "random" but stays stable) and can be overridden by the user from
// a palette. The chosen color hex is stored in User.avatar; an empty value means
// "use the auto color".

export const AVATAR_COLORS = [
  '#9a51e2', '#0ea5e9', '#e0245e', '#f97316', '#10b981',
  '#ec4899', '#eab308', '#1f2937', '#ffffff', '#5b5bd6',
];

export function isColor(v) {
  return typeof v === 'string' && /^#([0-9a-f]{3}|[0-9a-f]{6})$/i.test(v);
}

// Readable text color for a given background: dark text on light backgrounds
// (white, yellow), white text on dark/saturated ones.
export function textColorFor(bg) {
  if (!isColor(bg)) return '#fff';
  let hex = bg.replace('#', '');
  if (hex.length === 3) hex = hex.split('').map((c) => c + c).join('');
  const r = parseInt(hex.slice(0, 2), 16);
  const g = parseInt(hex.slice(2, 4), 16);
  const b = parseInt(hex.slice(4, 6), 16);
  const lum = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return lum > 0.6 ? '#1a1a2e' : '#fff';
}

export function getInitial(nameOrEmail) {
  const s = (nameOrEmail || '').trim();
  return s ? s.charAt(0).toUpperCase() : '?';
}

// Deterministic color from a string: same user always gets the same color.
export function colorFromString(str) {
  const s = str || '';
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) {
    hash = s.charCodeAt(i) + ((hash << 5) - hash);
  }
  return AVATAR_COLORS[Math.abs(hash) % AVATAR_COLORS.length];
}

// The background to use for a given user: their chosen color, or the auto one.
export function avatarBg(user) {
  if (isColor(user?.avatar)) return user.avatar;
  return colorFromString(user?.name || user?.email || '');
}
